import { Box, Button, CircularProgress } from "@mui/material";

import { Colors } from "../../config/styles";

import MainText from "../MainText";

type ComponetProps = {
  text?: string;
  loading?: boolean;
  icon?: JSX.Element;
  onClick?: () => void;
  fullWidth?: boolean;
  small?: boolean;
  color?: "black" | "white" | "danger";
};

export default function MainLinkButton({
  text,
  loading,
  icon,
  onClick,
  small,
  fullWidth = true,
  color = "black",
  ...props
}: ComponetProps) {
  return (
    <Button
      {...props}
      onClick={onClick}
      color="secondary"
      fullWidth={fullWidth}
      style={{
        height: small ? 40 : 60,
        borderRadius: "15px",
        textTransform: "none",
        backgroundColor: "transparent",
        color: color === "danger" ? Colors.Danger : "#000",
        border: "none",
      }}
    >
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <MainText color={color} size={small ? "caption" : "body"}>
          {text}
        </MainText>

        {loading ? (
          <Box style={{ marginLeft: 12, width: "26px" }} display={"flex"} alignItems={"center"}>
            <CircularProgress size={small ? "16px" : "20px"} color="inherit" />
          </Box>
        ) : icon ? (
          <Box
            style={{ marginLeft: 12, width: "26px" }}
            display={"flex"}
            alignItems={"center"}
            sx={{ "& .MuiSvgIcon-root": { color: "inherit" } }}
          >
            {icon}
          </Box>
        ) : null}
      </Box>
    </Button>
  );
}
